import { ComponentType } from 'preact'
import { StepComponentProps } from '~types/routers'
import { appendToTracking } from '../../Tracker'
import Document from './Document'
import Face from './Face'
import ProfileData from './ProfileData'
import ProofOfAddress from './ProofOfAddress'
import withCaptureVariant from './withCaptureVariant'

export const DocumentFrontCapture = appendToTracking(
  withCaptureVariant(Document, { side: 'front', requestedVariant: 'standard' }),
  'front_capture'
) as ComponentType<StepComponentProps>

export const DocumentBackCapture = appendToTracking(
  withCaptureVariant(Document, { side: 'back', requestedVariant: 'standard' }),
  'back_capture'
) as ComponentType<StepComponentProps>

export const PoACapture = appendToTracking(
  withCaptureVariant(ProofOfAddress, {}),
  'poa'
) as ComponentType<StepComponentProps>

export const SelfieCapture = appendToTracking(
  withCaptureVariant(Face, {
    requestedVariant: 'standard',
    pageId: 'SelfieCapture',
  }),
  'selfie_capture'
) as ComponentType<StepComponentProps>

export const FaceVideoCapture = appendToTracking(
  withCaptureVariant(Face, {
    requestedVariant: 'video',
    pageId: 'FaceVideoCapture',
  }),
  'face_video_capture'
) as ComponentType<StepComponentProps>

export const FaceMotionCapture = appendToTracking(
  withCaptureVariant(Face, {
    requestedVariant: 'motion',
    pageId: 'FaceMotionCapture',
  }),
  // The component includes multiple steps, so we let it suffix _capture or _alignment when needed.
  'face_motion'
) as ComponentType<StepComponentProps>

export const DataCapture = appendToTracking(ProfileData, 'data_capture')
